import React from 'react'
import download from "downloadjs";

export const downloadDocument = (doc) => {
    download(doc);
}